import React, { Suspense, useEffect, useRef } from "react";
import { Routes, useNavigate, Route, useLocation } from "react-router-dom";
import { PrivateRoute } from "./privateRoute";
import Dashboard from "../../pages/dashboard";
import MockTests from "../../pages/AllTests";
import TestSeries from "../../pages/testSeries";
import PracticeTests from "../../pages/practiceTests";
import CompletedTest from "../../pages/completedTest";
import FullMockTests from "../../pages/FullMockTests";
import Quiz from "../../pages/quiz";
import Payments from "../../pages/payments";
import QuizResults from "../../pages/quizResults";
import PracticeQuestions from "../../pages/practiceQuestions";
import Settings from "../../pages/Settings";
import Transactions from "../../pages/transactions";
import NotFoundPage from "../common/Errors/NotFoundPage";
import PracticeQuestionsSubjectTopic from "../../pages/practiceQuestionsSubjectTopic";
import TestSeriesQuestionView from "../../pages/testSeriesQuestionView";
import PracticeQuestionView from "../../pages/practiceQuestionView";
import SavedQuestionList from "../../pages/savedQuestionList";
import Reports from "../../pages/reports";
import SavedQuestionView from "../../pages/savedQuestionView";
import TestSeriesDetail from "../../pages/testSeriesDetail";
import PaymentResponse from "../../pages/payment-response";
import TestListByExams from "../../pages/TestListByExams";

import "../Profile/profile.scss"; //quick fix. ideally this css should be inside the component only.
import PracticeTestTopics from "../../pages/PracticeTestTopics";
import ErrorBlock from "../common/Errors/errorBlock";
import ExamTopicScreen from '../../pages/examTopicScreen';
import ExamScreen from '../../pages/examScreen';
/**
 * Navigation
 * @returns {*}
 * @constructor
 */
const Navigation = ({ paymentEnabled }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const ref = useRef(null);

  useEffect(() => {
    navigate(location);
    // To start listening for location changes...
    // let unListen = navigate.listen((obj) => {
    //     if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
    //         window.ReactNativeWebView.postMessage(obj.pathname);
    //     }
    // });
    // return () => {
    //     return unListen();
    // };
  }, []);
  return (
    <Routes>
      <Route
        path="/my-app/"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <Dashboard />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/practice/subject/:subjectId"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <PracticeTestTopics />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/tests"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <MockTests />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/test-series"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              {/* <ErrorBlock> */}
                <TestSeries />
              {/* </ErrorBlock> */}
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/practice-tests"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <PracticeTests />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/full-mock-tests"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <FullMockTests />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/completed-tests"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <CompletedTest />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/test-series/:id/tests"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              {/* <ErrorBlock> */}
                <TestSeriesDetail />
              {/* </ErrorBlock> */}
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/exams/:id"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <TestListByExams />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/reports"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <Reports />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/saved-questions"
        onUpdate={() => window.scrollTo(0, 0)}
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <SavedQuestionList />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/saved-questions/:slug"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <SavedQuestionView />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/practice/subject/:subject/topic/:topic/:type/:slug"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <PracticeQuestionView />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/test-series/:id/questions/:slug"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <TestSeriesQuestionView />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/practice"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <PracticeQuestions />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/practice/subject/:subject/topic/:topic"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <PracticeQuestionsSubjectTopic />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      {paymentEnabled && (
        <Route
          path="/my-app/transactions"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <PrivateRoute>
                <ErrorBlock>
                  <Transactions />
                </ErrorBlock>
              </PrivateRoute>
            </Suspense>
          }
        />
      )}
      <Route
        path="/my-app/settings"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <Settings />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      {paymentEnabled && (
        <Route
          path="/my-app/payments"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <PrivateRoute>
                <ErrorBlock>
                  <Payments />
                </ErrorBlock>
              </PrivateRoute>
            </Suspense>
          }
        />
      )}
      <Route
        path="/my-app/quiz/:mode/:slug"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <Quiz />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/tests/result/:id"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <QuizResults />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/payment-response/:transactionId"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <PaymentResponse />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/exam-topic-screen"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <ExamTopicScreen />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/my-app/exam-topic-screen/exams"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <PrivateRoute>
              <ErrorBlock>
                <ExamScreen />
              </ErrorBlock>
            </PrivateRoute>
          </Suspense>
        }
      />
      {/* <ScrollToTop> */}

      {/* <PrivateRoute exact path="/my-app/practice/subject/:subjectId" component={PracticeTestTopics}/>
                <Suspense fallback={<div>Loading...</div>}>
                    <PrivateRoute exact path="/my-app/tests" component={MockTests}/>
                    <PrivateRoute exact path="/my-app/test-series" component={TestSeries}/>
                    <PrivateRoute exact path="/my-app/practice-tests" component={PracticeTests}/>
                    <PrivateRoute exact path="/my-app/full-mock-tests" component={FullMockTests}/>
                    <PrivateRoute exact path="/my-app/completed-tests" component={CompletedTest}/>
                    <PrivateRoute exact path="/my-app/test-series/:id/tests" component={TestSeriesDetail}/>
                    <PrivateRoute exact path="/my-app/exams/:id" component={TestListByExams}/>
                    <PrivateRoute exact path="/my-app/reports" component={Reports}/>
                    <PrivateRoute exact path="/my-app/saved-questions" component={SavedQuestionList}
                                  onUpdate={() => window.scrollTo(0, 0)}/>
                    <PrivateRoute exact path="/my-app/saved-questions/:slug" component={SavedQuestionView}/>
                    <PrivateRoute exact path="/my-app/practice/subject/:subject/topic/:topic/:type/:slug"
                                  component={PracticeQuestionView}/>
                    <PrivateRoute exact path="/my-app/test-series/:id/questions/:slug"
                                  component={TestSeriesQuestionView}/>
                    <PrivateRoute exact path="/my-app/practice" component={PracticeQuestions}/>
                    <PrivateRoute exact path="/my-app/practice/subject/:subject/topic/:topic"
                                  component={practiceQuestionsSubjectTopic}/>
                    {
                        paymentEnabled && <PrivateRoute exact path="/my-app/transactions" component={Transactions}/>
                    }
                    <PrivateRoute exact path="/my-app/settings" component={Settings}/>
                    {
                        paymentEnabled && <PrivateRoute exact path="/my-app/payments" component={Payments}/>
                    }
                    <PrivateRoute exact path="/my-app/quiz/:mode/:slug" component={Quiz}/>
                    <PrivateRoute exact path="/my-app/tests/result/:id" component={QuizResults}/>
                    <PrivateRoute exact path="/my-app/payment-response/:transactionId" component={PaymentResponse}/>
                </Suspense> */}
      <Route
        path="*"
        element={
          <Suspense fallback={<div>Loading...</div>}>
            <NotFoundPage component={NotFoundPage} />
          </Suspense>
        }
      />
    </Routes>
  );
};

export default Navigation;
